import { render, staticRenderFns } from "./AdminClients.vue?vue&type=template&id=1cdeace8&scoped=true&"
import script from "./AdminClients.vue?vue&type=script&lang=js&"
export * from "./AdminClients.vue?vue&type=script&lang=js&"
import style0 from "./AdminClients.vue?vue&type=style&index=0&id=1cdeace8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdeace8",
  null
  
)

export default component.exports